module.exports = __webpack_public_path__ + "img/PERCENT.508ad0fc.svg";